import * as React from 'react';

import { cn } from '@/lib/utils';

export type TextareaProps = React.TextareaHTMLAttributes<HTMLTextAreaElement>;

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, ...props }, ref) => (
    <textarea
      ref={ref}
      className={cn(
        // Egységes az Input-mezővel: `input-glass` felület/keret (mindkét témában) + a közös `.input-glass:focus`
        // CSS adja a halvány zöld focus-ringet (nincs külön `border-ring`/glow itt).
        'input-glass text-md ease-atlas flex min-h-[80px] w-full rounded-lg border px-3 py-2 transition-[border-color,box-shadow] duration-150',
        'placeholder:text-subtle focus-visible:outline-none',
        'disabled:cursor-not-allowed disabled:opacity-50',
        className,
      )}
      {...props}
    />
  ),
);
Textarea.displayName = 'Textarea';

export { Textarea };
